import styles from "./MediaArticleField.module.scss";

interface MediaArticleFieldProps {
  article?: string;
}

const MediaArticleField = ({ article }: MediaArticleFieldProps) => {
  // nosemgrep
  return (
    <div
      className={styles.article}
      dangerouslySetInnerHTML={{ __html: article || "" }}
    />
  );
};

export default MediaArticleField;
